const moment = require('moment');

function ogDayLocaleFilter($translate) {
  return function (index, characterCount = undefined) {
    moment.locale($translate.use());
    const weekArray = moment.weekdays();

    if (index >= weekArray.length) {
      return String();
    }
    if (angular.isUndefined(characterCount) || characterCount > weekArray[index].length) {
      return weekArray[index].toLowerCase();
    }
    return weekArray[index].substring(0, characterCount).toUpperCase();
  };
}

ogDayLocaleFilter.$inject = ['$translate'];

module.exports = ogDayLocaleFilter;
